import * as React from "react";
import AppBody from "../components/AppBody";
import { CgSpinner } from "react-icons/cg";
import Header from "../components/Header";
import { ImpressionType } from "../lib/constants";
import RouteTitle from "../components/RouteTitle";
import useSearchResults from "../services/savvy/useSearchResults";
export default function AgentSuccessPage() {
    var searchQuery = useSearchResults({
        impressionTypeOverride: ImpressionType.AgentStandard,
    }).searchQuery;
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, null),
        React.createElement(AppBody, null, searchQuery.isSuccess ? (React.createElement(React.Fragment, null,
            React.createElement(RouteTitle, { className: "mb-4 mt-6 text-center font-bold" }, "Profile updated"),
            React.createElement("p", { className: "text-center text-black-300" }, "Please return to Retool to review quotes."))) : (React.createElement(React.Fragment, null,
            React.createElement(CgSpinner, { className: "h-16 w-16 animate-spin", color: "#555" }))))));
}
